export const numberToBrl = (amount: number): string => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  }).format(amount);
};

export const convertApiNumberStringToNumber = (number: string) => {
  return Number(number.replace(".", "").replace(",", "."));
};

export const splitCurrencyValue = (
  value: number
): { symbol: string; amount: string } => {
  const formattedValue = numberToBrl(value);
  return {
    symbol: formattedValue.substring(0, 3),
    amount: formattedValue.substring(3)
  };
};
